import React, { useEffect, useState } from 'react'
import { APIService } from 'api/APIService'
import { RequestError } from 'api/errors'
import { Loader } from 'components/Utility/Loader/Loader'
import styles from './GiftCardsPage.module.scss'

/** Error code the API sends when the bank has no status for the order yet */
const STATUS_FAILED = 'STATUS_FAILED'

const errorText = (error: unknown, orderId: string) => {
  if (error instanceof RequestError && error.code === STATUS_FAILED) {
    return 'Не удалось получить статус заказа'
  }
  return `Неизвестная ошибка при получении статуса.\nНомер заказа:\n ${orderId}`
}

/** The page the bank returns to with ?orderId=…: checks and shows the payment result */
export const GiftCardsStatus: React.FC<{ orderId: string }> = ({ orderId }) => {
  const [pending, setPending] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setPending(true)
    APIService.certificates.checkOrderStatus(orderId)
      .catch((e) => setError(errorText(e, orderId)))
      .finally(() => setPending(false))
  }, [orderId])

  if (error !== null) {
    return (
      <div className={styles.paymentStatusError}>
        <div className={styles.paymentErrorIconContainer}>
          <i className={styles.paymentErrorIcon} />
        </div>
        <div className={styles.statusTextContainer}>
          {error}
        </div>
      </div>
    )
  }

  if (pending) {
    return (
      <div className={styles.paymentStatusPending}>
        <div className={styles.paymentLoaderContainer}>
          <Loader size={48} />
        </div>
        <div>
          Проверяем статус оплаты
        </div>
      </div>
    )
  }

  return (
    <div className={styles.paymentStatusSuccess}>
      <div className={styles.paymentSuccessIconContainer}>
        <i className={styles.paymentSuccessIcon} />
      </div>
      <div className={styles.statusTextContainer}>
        Оплата прошла успешно
      </div>
    </div>
  )
}
